"use client";

import { ReactNode } from "react";

import { ChatMetaDataProvider } from "./ChatMetaDataProvider";
import { ConversationsProvider } from "./ConversationsProvider";
import { MessagesProvider } from "./MessagesProvider";
import { SelectedConversationProvider } from "./SelectedConversationProvider";

export interface IChatProvidersProps {
  children: ReactNode;
}

export function ChatProviders({
  children,
}: Readonly<IChatProvidersProps>): JSX.Element {
  return (
    <ChatMetaDataProvider>
      <ConversationsProvider>
        <SelectedConversationProvider>
          <MessagesProvider>{children}</MessagesProvider>
        </SelectedConversationProvider>
      </ConversationsProvider>
    </ChatMetaDataProvider>
  );
}
